export default __webpack_public_path__ + "static/hero-d91b2486a50221fd2ae7b8557c7ee189.png";